import Vue from "vue";
export default Vue.extend({
    props: ["title", "icon", "subtitle", "active"],
    methods: {
        onCopy() {
            navigator.clipboard.writeText(this.subtitle);
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: `Copied stackorder id to clipboard`,
            });
        },
    },
});
